import Prismic from 'prismic-javascript';
import { fetchPrismicData } from 'filou-web';
import sortBy from 'lodash/sortBy';

const slugify = str =>
  str
    ? str
        .toLowerCase()
        .split(' ')
        .join('-')
        .split('.')
        .join('')
        .split('/')
        .join('-')
        .split('ö')
        .join('oe')
        .split('ä')
        .join('ae')
        .split('ü')
        .join('ue')
        .split('ß')
        .join('ss')
        .split('dr-')
        .join('')
        .split('pd-')
        .join('')
        .split('med-')
        .join('')
        .split('univ-de-bruxelles-')
        .join('')
    : str;
const slugifyArray = (arr, property = 'name', toProperty = 'slug') =>
  arr.map(x => ({ ...x, [toProperty]: slugify(x[property]) }));
const fetchData = async api => {
  const { partne, ...mapped } = await fetchPrismicData(api);
  mapped.partner = partne;
  mapped.spezialist = slugifyArray(mapped.spezialist);

  return {
    template: mapped.template[0],
    spezialist: mapped.spezialist.reduce(
      (state, item) => ({
        ...state,
        [item.id]: item
      }),
      {}
    ),
    partner: mapped.partner.reduce(
      (state, item) => ({
        ...state,
        [item.id]: item
      }),
      {}
    ),
    spezialistList: sortBy(
      mapped.spezialist.map(x => ({
        id: x.id,
        slug: x.slug,
        name: x.name,
        bild: x.bild,
        schwerpunkt: x.schwerpunkt
      })),
      x => x.name.split(' ').reverse()[0]
    ),
    partnerList: mapped.partner.map(x => ({
      id: x.id,
      name: x.name,
      logo: x.logo
    }))
  };
};
export default fetchData;
